import { Schema } from '../../types'
import { commonColumns } from '../common_schema'

export const rocksdbRaftSchema: Schema = {
  title: 'RocksDB raft',
  level: 3,
  columns: commonColumns
}
